import { S7_MUTED, S7_SPARK } from "../../Utils/Helper/discoveryHubUi";

type Props = {
  series: (number | null | undefined)[];
  width?: number;
  height?: number;
};

const MiniSparkline = ({ series, width = 80, height = 22 }: Props) => {
  const vals = series.filter((v): v is number => v != null && !Number.isNaN(v));
  if (vals.length < 2) {
    return <span className={S7_MUTED}>—</span>;
  }

  const min = Math.min(...vals);
  const max = Math.max(...vals);
  const range = max - min || 1;

  const pts = series
    .map((v, i) => {
      if (v == null || Number.isNaN(v)) return null;
      const x = (i / (series.length - 1)) * (width - 4) + 2;
      const y = height - 2 - ((v - min) / range) * (height - 4);
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .filter((p): p is string => p != null);

  const lastVal = vals[vals.length - 1];
  const firstVal = vals[0];
  const color = lastVal >= firstVal ? "#16a34a" : "#dc2626";

  return (
    <svg
      className={S7_SPARK}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
    >
      <polyline
        fill="none"
        stroke={color}
        strokeWidth={1.5}
        points={pts.join(" ")}
      />
    </svg>
  );
};

export default MiniSparkline;
